<template>
  <div class="p-6">
    <!-- Sub-tabs -->
    <Page_Tabs
      :tabs="tabs"
      :initial-tab="activeTab"
      class="mb-4"
      @select="activeTab = $event"
    />

    <!-- Address Roster Report -->
    <div v-show="activeTab === 'Address Roster Report'" class="border border-gray-200 rounded-lg overflow-hidden">
      <AddressRosterReport
        v-if="visited.includes('Address Roster Report')"
        @preview-practice="previewPractice"
      />
    </div>

    <!-- What a practice would see when asked to validate its addresses -->
    <div v-show="activeTab === 'Practice Rostering View'" class="border border-gray-200 rounded-lg overflow-hidden">
      <PracticeRosterView
        v-if="visited.includes('Practice Rostering View')"
        :initial-practice="practiceToPreview"
      />
    </div>

    <!-- Provider Roster Report -->
    <div v-show="activeTab === 'Provider Roster Report'" class="border border-gray-200 rounded-lg overflow-hidden">
      <ProviderRosterReport
        v-if="visited.includes('Provider Roster Report')"
        @preview-practice="previewProviderPractice"
      />
    </div>

    <!-- What a practice would see when asked to validate its providers -->
    <div v-show="activeTab === 'Practice Provider View'" class="border border-gray-200 rounded-lg overflow-hidden">
      <PracticeProviderView
        v-if="visited.includes('Practice Provider View')"
        :initial-practice="providerToPreview"
      />
    </div>
  </div>
</template>

<script>
import AddressRosterReport from './AddressRosterReport.vue'
import PracticeRosterView from './PracticeRosterView.vue'
import ProviderRosterReport from './ProviderRosterReport.vue'
import PracticeProviderView from './PracticeProviderView.vue'
import Page_Tabs from '@/components/widgetcomponents/Page_Tabs.vue'

export default {
  name: 'Rostering_Test',
  components: {
    AddressRosterReport,
    PracticeRosterView,
    ProviderRosterReport,
    PracticeProviderView,
    Page_Tabs,
  },
  data() {
    return {
      activeTab: 'Address Roster Report',
      tabs: [
        'Address Roster Report',
        'Practice Rostering View',
        'Provider Roster Report',
        'Practice Provider View',
      ],
      // Mount each tab's component only once opened, so nothing fetches until
      // the user asks for it.
      visited: ['Address Roster Report'],
      practiceToPreview: null,
      providerToPreview: null,
    }
  },
  watch: {
    activeTab(tab) {
      if (!this.visited.includes(tab)) this.visited.push(tab)
    },
  },
  methods: {
    // Jump from an address report row straight into that practice's address view.
    previewPractice(practiceEntityId) {
      this.practiceToPreview = practiceEntityId
      this.openTab('Practice Rostering View')
    },
    // Jump from a provider report row straight into that practice's provider view.
    previewProviderPractice(practiceEntityId) {
      this.providerToPreview = practiceEntityId
      this.openTab('Practice Provider View')
    },
    openTab(tab) {
      this.activeTab = tab
      if (!this.visited.includes(tab)) this.visited.push(tab)
    },
  },
}
</script>
